import OrdersGeneric from "../components/orders/paginated/OrdersGeneric";

/**
 * Component for Orders
 * @returns
 */
export default function Orders() {
  return (
    <OrdersGeneric
      ordersTitle="Uppdrag"
      fetchArchived={false}
      fetchMyOrders={false}
    />
  );
}
